import { Vue } from 'vue-property-decorator';

export class Bus extends Vue {

  on(ev: string, callback: Function) {
    this.$on(ev, callback);
    // console.log(ev)
  }

  off(ev: string, callback?: Function) {
    this.$off(ev, callback);
  }

  once(ev: string, callback: Function) {
    this.$once(ev, callback);
  }

  emit(ev: string, ...args: any[]) {
    this.$emit(ev, ...args);
  }

}

export default new Bus();
